import firestoreServices from 'src/services/firestore.service';
import insurersServices from 'src/services/insurers.services';
import firebase from 'firebase';
import worksServices from './works.services';

const accidentsFirestoreServices = firestoreServices('accidents');

const getSubcollection = async doc => {
  let data = doc.data();
  for (let key in data) {
    const item = data[key];
    if (typeof item === 'object' && item && item.parent) {
      await firestoreServices(item.parent.id).get(item.id, async itemData => {
        data[key] = itemData;
      });
    }
  }
  return { id: doc.id, ...data };
};

const listElements = queryResult => {
  const elements = queryResult.docs.map(async (doc, _) => {
    return await getSubcollection(doc);
  });

  return Promise.all(elements);
};

export default {
  ...accidentsFirestoreServices,
  add: (data, onSuccess, onError = _ => {}) => {
    if (typeof data.insurer.id === 'string' || data.insurer.id instanceof String) {
      data.insurer = insurersServices.docRef(data.insurer.id);
    }
    data.createdAt = firebase.firestore.Timestamp.fromDate(
      new Date()
    );
    return accidentsFirestoreServices.add(
      { ...data, isActive: true },
      onSuccess,
      onError
    );
  },
  update: (id, data, onSuccess, onError = _ => {}) => {
    const onUpdated = () => {
      onSuccess()
      if(data.status === 'CANCELED'){
        worksServices.withNoStatus( id,'CANCELED', (result) => {
          let promValues = []
          result.forEach((doc, _) => {
              promValues.push(
                new Promise(res => {
                  worksServices.update(doc.id, {
                    status: 'CANCELED'
                  },
                    () => {res(true)},
                  );
                }))})
            Promise.all(promValues).then(result => console.log('works updated'))
          })
      }
    }
    if (typeof data.insurer.id === 'string' || data.insurer.id instanceof String) {
      data.insurer = insurersServices.docRef(data.insurer.id);
    }
    return accidentsFirestoreServices.update(id, data, onUpdated, onError);
  },
  getAll: (onResult, onError = _ => {}) =>
    accidentsFirestoreServices
      .collectionRef()
      .get()
      .then(async queryResult => onResult(await listElements(queryResult)))
      .catch(onError),
};
